import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import PaymentBox from "../dataitem/PaymentBox";
import dayjs from "dayjs";
import SimpleBox from "../layout/container/SimpleBox";

const CalendarYear = ({ payments, selectedYear }) => {

    const theme = useTheme();
    const months = dayjs.localeData().monthsShort();

    return (
        <SimpleBox flexDirection="column">
            <SimpleBox justifyContent="center">
                <Typography sx={{fontSize: "1.5rem", fontWeight: "bold", height: "100%"}}>{selectedYear}</Typography>
            </SimpleBox>
            <Grid container sx={{marginTop: theme.spacing(1), alignItems: "center", textAlign: "center"}} spacing={theme.spacing(1)}>
                {
                    months.map((month, index) => {
                        const findPayment = Boolean(payments) ? payments.filter(element => element.paymentMonth === index + 1) : [];
                        const payment = findPayment.length > 0 ? findPayment[0] : {
                            id: null,
                            amount: 0,
                            paymentStatus: null,
                        };
                        return (
                            <Grid item xs={4} key={index}>
                                <PaymentBox paymentStatus={payment.paymentStatus} label={month} amount={payment.amount} />
                            </Grid>
                        );
                    })
                }
            </Grid>
        </SimpleBox>
    )
}

export default CalendarYear;
